export const environment = {
  production: true,
  Build_Timestamp: '02/05/2026 04:10:51 PM CST',
};
